import React from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useFollowingStatus } from '../../hooks/useFollowingStatus';
import { useNotification } from '../../context/NotificationContext';
import styles from './FollowButton.module.css';

const FollowButton = ({ programId, programName, className = '', disabled = false, showText = false }) => {
  const { 
    isFollowing, 
    loading, 
    toggleFollow,
    followedAt 
  } = useFollowingStatus(programId);
  
  const { showSuccess, showError } = useNotification();

  const handleToggleFollow = async () => {
    if (disabled || loading) return;

    try {
      const result = await toggleFollow();
      
      if (result.isFollowing) {
        showSuccess(`You are now following ${programName}`, {
          duration: 4000,
          autoClose: true
        });
      } else {
        showSuccess(`You unfollowed ${programName}`, {
          duration: 4000,
          autoClose: true
        });
      }
    } catch (error) {
      showError(error.message || 'Failed to update following status');
    }
  };

  const getTooltipText = () => {
    if (loading) return 'Loading...';
    if (isFollowing) {
      return followedAt 
        ? `Following since ${new Date(followedAt).toLocaleDateString()}`
        : 'Following - Click to unfollow';
    }
    return 'Click to follow this program';
  };

  const getButtonClass = () => {
    let baseClass = `${styles.followButton} ${className}`;
    if (showText) {
      baseClass += ` ${styles.withText}`;
    }
    if (isFollowing) {
      return `${baseClass} ${styles.following}`;
    }
    return `${baseClass} ${styles.notFollowing}`;
  };

  return (
    <button
      className={getButtonClass()}
      onClick={handleToggleFollow}
      disabled={disabled || loading}
      title={getTooltipText()}
    >
      {loading ? (
        <span className={styles.loadingIcon}>⏳</span>
      ) : isFollowing ? (
        <>
          <FaEye className={styles.eyeIcon} />
          {showText && <span>Unfollow</span>}
        </>
      ) : (
        <>
          <FaEyeSlash className={styles.eyeIcon} />
          {showText && <span>Follow</span>}
        </>
      )}
    </button>
  );
};

export default FollowButton;

